export default "__VITE_ASSET__B9i3wzjd__"